import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StartupService } from 'src/app/core/services/startup.service';

export const uploadInternshipDocumentGuard: CanActivateFn = (route, state) => {
  const startupService = inject(StartupService)
  const router = inject(Router)
  if (startupService.isPortalContratanet()) {
    return startupService.isPortalContratanet()
  }
  router.navigate(['/unauthorized'])
};
